/* eslint-disable */
import moment from 'moment'

const state = () => ({
    selectedDate: moment(),
    localDateString: '',
    datePickerInitialStartDate: null,
    datePickerStartDate: null,
    datePickerEndDate: null
});

const mutations = {
    setSelectedDate(state, date) {
        state.selectedDate = date;
        state.localDateString = moment(date).format('YYYY-MM-DD');
    },
    setDatePickerInitialStartDate(state, date) {
        state.datePickerInitialStartDate = date;
    },
    setDatePickerStartDate(state, date) {
        state.datePickerStartDate = date
    },
    setDatePickerEndDate(state, date) {
        state.datePickerEndDate = date;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
};
